$(document).ready(function () {
   "use strict";

    const scrollLink = $(".js_scrollToSection");

    if (scrollLink.length > 0) {
        console.log('scrollLink');
        scrollLink.click(function(e) {
            const url = new URL(window.location.href);
            const isNewsHome = url.pathname == '/news' || url.pathname == '/news/';
            const params = Object.fromEntries(url.searchParams.entries());
            const hasParams = Object.keys(params).length > 0;
            console.log('url');
            console.log(url);
            console.log('isNewsHome');
            console.log(isNewsHome);
            console.log('params');
            console.log(params);
            console.log('hasParams');
            console.log(hasParams);

            if (!newsHome || hasParams) {
                console.log('normal link');
                return;
            }
            console.log('do not prevent default');

            e.preventDefault();

            $('html, body').animate({
                scrollTop: $("." + $(this).data("id")).offset().top
            }, 1000);
        });
    }
});
